import cx from 'classnames';
import { upperCaseFirst } from 'mk/bazaar/common/filters';
import { photoUrl } from 'mk/photo/photoUrl';
import Emojify from 'mk2/components/Emojify';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './Cover.mscss';

const bestVersion = (photo: PhotoEntity) => {
    if (photo.versions.includes('s1600x1600')) {
        return 's1600x1600';
    }

    if (photo.versions.includes('s742xn')) {
        return 's742xn';
    }

    return 's1600x1600';
};

interface OwnProps {
    className?: string;
    photo?: PhotoEntity;
    title: string;
    icon?: string;
    subtitle?: React.ReactNode;
}

type Props = OwnProps;

const Cover: React.StatelessComponent<Props> = ({ className, photo, title, icon, subtitle }) => (
    <div className={cx(styles.Cover, className)}>
        {photo &&
            <div
                className={cx(
                    styles.Cover__photo,
                    photo.width / photo.height >= 980 / 335 ?
                        styles['Cover__photo--trimX'] :
                        styles['Cover__photo--trimY'],
                )}
                style={{
                    backgroundImage: `url('${photoUrl(photo, bestVersion(photo))}')`,
                }}
            />
        }
        {!photo &&
            <i className={cx('fa', 'fa-camera', styles.Cover__placeholder)}/>
        }
        <div className={styles.Cover__text}>
            <h1 className={styles.Cover__title}>
                {icon && <i className={cx(styles.Cover__title__icon, 'fa', `fa-${icon}`)} />}
                <Emojify size={24}>
                    {upperCaseFirst(title)}
                </Emojify>
            </h1>
            {subtitle && (
                <div className={styles.Cover__subtitle}>
                    {subtitle}
                </div>
            )}
        </div>

    </div>
);

Cover.displayName = 'Cover';

export default Cover;
